<template>
        <div class="box box-info">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
                  <label for="billNo" >Bill No:</label>
                  <span class="purchaseOutput "><b>{{UnsettledData!== undefined?UnsettledData.billNo: ''}}</b></span>
              </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="salesDate" >Date:</label>
                  <span class="purchaseOutput"><b>{{UnsettledData!== undefined?UnsettledData.salesDateNepali:''}}</b></span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="WarehouseName" >Payment method:</label>
                  <span class="purchaseOutput ">
                    <b>{{UnsettledData!== undefined?UnsettledData.paymentMethod:''}} </b>
                  </span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="WarehouseName" >Contact Number</label>
                  <span class="purchaseOutput ">
                    <b>{{UnsettledData!== undefined?UnsettledData.contactNumber:''}} </b>
                  </span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="billprefix" >Bill Prefix</label>
                  <span class="purchaseOutput ">
                    <b>{{UnsettledData!== undefined?UnsettledData.billPrefix:''}} </b>
                  </span>
               </div>
             </div>
               <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th scope="col">SN</th>
                    <th scope="col">Item Name</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Rate</th>
                     <th scope="col">Size</th>
                    <th scope="col">Amount</th>
                  </tr>
                </thead>
                <tbody  v-for="(pd,index) in UnsettledData!== undefined?UnsettledData.childSalesDetailsDTOList:'' " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{pd.itemName}}</td>
                    <td>{{pd.quantity}}</td>
                    <td>{{pd.sellingPrice}}</td>
                     <td>{{pd.sizeDetails}}</td>
                    <td>{{(pd.quantity * pd.sellingPrice).toFixed(4)}} </td>
                  </tr>
                </tbody>
              </table>
              <hr>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
              <b style="margin-left: 15em;">Total:</b>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <!-- <b style="margin-left: 16em;">{{ totalQty }}</b> -->
            </div>
            <div class="p-field p-col-12 p-md-3">
              <b style="margin-left: 12em;">{{ UnsettledData.childSalesDetailsDTOList[UnsettledData.childSalesDetailsDTOList.length - 1].sumQty }}</b>
            </div>

            <div class="p-field p-col-12 p-md-3">
              <b style="margin-left: 12em;">{{ UnsettledData.childSalesDetailsDTOList[UnsettledData.childSalesDetailsDTOList.length - 1].sumAmount}}</b>
            </div>
            
          </div>
          <hr>
               <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                  <label for="subttotal" >Remarks: </label>
                   <span class="purchaseOutput ">
                    <b>{{UnsettledData!== undefined?UnsettledData.remarks:''}} </b>
                  </span>
                </div>
               
                <!-- <div class="p-fluid p-formgrid p-grid"> -->
                    <div class="p-field p-col-12 p-md-2">
                  <label for="subttotal" >Delivery Address: </label>
                   <span class="purchaseOutput ">
                    <b>{{UnsettledData!== undefined?UnsettledData.deliveryAddress:''}} </b>
                  </span>
                </div>
               <!-- </div> -->
                <!-- <div class="p-fluid p-formgrid p-grid"> -->
                    <div class="p-field p-col-12 p-md-2">
                  <label for="subttotal" >Delivery Amount: </label>
                   <span class="purchaseOutput ">
                    <b>{{UnsettledData!== undefined?UnsettledData.deliveryAmount:''}} </b>
                  </span>
                </div>
               <!-- </div> -->

               </div>
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="subttotal" >Sub-Total: </label>
                  <span id="subttotal"> {{UnsettledData!== undefined?UnsettledData.subTotalAmount:0}} </span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="discountAmt">Discount Amt:</label>
                  <span id="discountAmt">{{UnsettledData!== undefined?UnsettledData.discountAmt:0}}</span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="nontaxable">Non-taxable:</label>
                  <span id="nontaxable">{{UnsettledData!== undefined?UnsettledData.nonTaxableAmount:0}}</span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="taxable">Taxable:</label>
                  <span id="taxable">{{UnsettledData!== undefined?UnsettledData.taxableAmount:0}}</span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="tax">Tax(13%):</label>
                  <span id="tax">{{UnsettledData!== undefined?UnsettledData.vatAmount:0}}</span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="total">Total:</label>
                  <span id="total">{{UnsettledData!== undefined?UnsettledData.billAmount:0}}</span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="tenderAmt">Tender Amount:</label>
                  <span id="tenderAmt" >{{UnsettledData!== undefined?UnsettledData.tenderAmount:0}}</span>
                </div>
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                  <label for="returnAmt">Return Amount:</label>
                  <span id="returnAmt" >{{UnsettledData!== undefined?UnsettledData.returningAmount:0}}</span>
                </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-10"></div>
                <div class="p-field p-col-12 p-md-2">
                <Button class="p-button-raised p-button-danger "
                label="Back" @click.prevent="$router.back()"/>
              </div>
            </div>
          </div>
</template>
<script>
import Button from 'primevue/button'
export default {
  name: 'UnsettledDetails',
  props: ['UnsettledData'],
  data() {
    return {
    }
  },
  mounted() {
    this.checkIfPageReload()
  },
  methods: {
    checkIfPageReload() {
      if (this.UnsettledData === undefined) {
        this.$router.back()
        return
      }
    }
  },
  components: {
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// posUnsettledDetails.vue?0f8be41f